/**
* File preview component for selected files in input area
*/

import type { ThemePalette } from '../utils/themeUtils'
import { getFileIcon, getMessageTypeFromFile } from '../utils/fileUtils'

interface FilePreviewProps {
    file: File
    preview: string | null
    onRemove: () => void
    palette: ThemePalette
}

export function FilePreview({ file, preview, onRemove, palette }: FilePreviewProps) {
    return (
        <div
        style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px',
            marginTop: '8px',
            background: palette.panelSurface,
            borderRadius: '12px',
            border: `1px solid ${palette.border}`,
        }}
        >
        {preview ? (
            // Image preview
            <div
            style={{
                position: 'relative',
                width: '80px',
                height: '80px',
                borderRadius: '8px',
                overflow: 'hidden',
                flexShrink: 0,
            }}
            >
            <img
            src={preview}
            alt="Preview"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
            }}
            />
            </div>
        ) : (
            // File icon for non-image files
            <div
            style={{
                width: '80px',
                height: '80px',
                borderRadius: '8px',
                background: palette.assistantBubble,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px',
                flexShrink: 0,
            }}
            >
            {getFileIcon(file.type, getMessageTypeFromFile(file))}
            </div>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 500, fontSize: '14px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {file.name}
        </div>
        <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '4px' }}>
        {(file.size / 1024 / 1024).toFixed(2)} MB
        </div>
        </div>
        <button
        type="button"
        onClick={onRemove}
        style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            border: 'none',
            background: palette.assistantBubble,
            color: palette.textPrimary,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            fontWeight: 'bold',
            flexShrink: 0,
        }}
        aria-label="Remove file"
        >
        ×
        </button>
        </div>
    )
}
